import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer';
import { extrudeSettings, textureAnisotropy } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';

const RollUpDoorDegree = ({ width, height, trimWidth,doorColor, isOverlap, overlapTrimColor }) => {
    const trimColor = useMemo(() => {

            return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])
    

    const trimModel = useMemo(() => {
        let trimOffset;
        if(width >= 2.5){
            trimOffset = 1
        } else {
            trimOffset = width / 3
        }
        const offset = 0.05

        const model = new THREE.Shape();
        model.moveTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2 - trimOffset);
        model.lineTo(-width / 2 + trimOffset,  height / 2 );
        model.lineTo(width / 2 - trimOffset,  height / 2 );
        model.lineTo(width / 2,  height / 2 - trimOffset);
        model.lineTo(width / 2,  -height / 2 );
        model.lineTo(width / 2 - trimWidth,  -height / 2 );
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimOffset - offset);
        model.lineTo(width / 2 - trimOffset - offset,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimOffset + offset,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimOffset - offset);
        model.lineTo(-width / 2 + trimWidth,  -height / 2 );
        model.closePath();    
        
        return model;
    }, [width, height, trimWidth])

    const delModel = useMemo(() => {
        let trimOffset;
        if(width >= 2.5){
            trimOffset = 1
        } else {
            trimOffset = width / 3
        }
        const model = new THREE.Shape();
        model.moveTo(-width / 2 ,  height / 2 - trimOffset - trimWidth);
        model.lineTo(-width / 2 ,  height / 2 );
        model.lineTo(-width / 2 + trimOffset + trimWidth,  height / 2 );
        model.closePath();    
        
        return model;
    }, [width, height, trimWidth])

    const doorSideModel = useMemo(() => {
        const initPatternSize = 0.3;
        const initPatternCount = Math.floor(height / initPatternSize);
        let patternCount = initPatternCount;
        if (height - initPatternSize * initPatternCount >= initPatternSize / 2) patternCount += 1;
        const patternSize = height / patternCount;
        const unitPatternSize = patternSize / 6;

        const model = new THREE.Shape();
        model.moveTo(0, 0);
        let initPos = 0
        new Array(patternCount - 1).fill("").map((_, index) => {
            initPos = patternSize * index;
            model.lineTo(0, initPos + 0);
            model.lineTo(0, initPos + unitPatternSize * 1);
            model.lineTo(unitPatternSize * 1.5, initPos + unitPatternSize * 2);
            model.lineTo(unitPatternSize * 1.5, initPos + unitPatternSize * 4);
            model.lineTo(0, initPos + unitPatternSize * 5);
            model.lineTo(0, initPos + unitPatternSize * 6);
        })
        model.lineTo(-0.005, initPos + patternSize);
        model.lineTo(-0.005, 0);
        model.closePath();

        return model
    }, [width, height])


    const meshDoorModel = new THREE.Mesh(new THREE.ExtrudeGeometry(doorSideModel, extrudeSettings(width - trimWidth * 2)));
    const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

    let meshDoorModel_Temp = meshDoorModel.clone();
    meshDoorModel_Temp.position.set(-(-width / 2 + trimWidth), -height / 2 + 0.25, 0.05);
    meshDoorModel_Temp.rotateY(-Math.PI / 2)
    meshDoorModel_Temp.updateMatrixWorld();

    let meshLeftDelModel_Temp = meshDelModel.clone();
    meshLeftDelModel_Temp.position.set(0, 0, -0.5);
    meshLeftDelModel_Temp.updateMatrixWorld();

    let meshRightDelModel_Temp = meshDelModel.clone();
    meshRightDelModel_Temp.position.set(0, 0, 0.5);
    meshRightDelModel_Temp.rotateY(Math.PI )
    meshRightDelModel_Temp.updateMatrixWorld();

    const meshDoorModel_CSG = CSG.fromMesh(meshDoorModel_Temp);
    const meshLeftDelmodel_CSG = CSG.fromMesh(meshLeftDelModel_Temp)
    const meshRightDelmodel_CSG = CSG.fromMesh(meshRightDelModel_Temp)

    const DoorModel_CSG = meshDoorModel_CSG.subtract(meshLeftDelmodel_CSG)
    const meshRightDel_CSG = DoorModel_CSG.subtract(meshRightDelmodel_CSG)
    const meshleftDel_CSG = meshRightDel_CSG.subtract(meshRightDelmodel_CSG)
    const CSGDoorModel = CSG.toMesh(
        meshleftDel_CSG,
        new THREE.Matrix4(),
    )
    
    const bottomMetalPartModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2 + trimWidth,  -height / 2 + 0.3);
        model.lineTo(width / 2 - trimWidth,  -height / 2 + 0.3);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.closePath();

        return model;
    }, [width, height, trimWidth])
    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={isOverlap ? overlapTrimColor : trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            {new Array(2).fill("").map((_, index) =>     
                <mesh key={index} geometry={CSGDoorModel.geometry} castShadow receiveShadow rotation={[0, index * Math.PI, 0]} position={[0, 0, index * 0.1]}> 
                    <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                </mesh>  
            )}
            {/* <mesh geometry={CSGDoorModel.geometry} castShadow receiveShadow > 
                <meshStandardMaterial  color={'white'} side={THREE.DoubleSide} roughness={0.4} metalness={0.3} emissive={'#160C02'} />
            </mesh> */}
            <mesh name='bottom' position={[0, 0, 0.025]}>
                <extrudeGeometry args={[bottomMetalPartModel, extrudeSettings(0.05)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} metalness={0.6} roughness={0.2} />
            </mesh>
        </>
    )
}

export default RollUpDoorDegree